var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManageUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.32301 6.33361C6.03943 7.0294 7.01112 7.42028 8.02429 7.42028C9.03747 7.42028 10.0092 7.0294 10.7256 6.33361C11.442 5.63782 11.8445 4.69413 11.8445 3.71014C11.8445 2.72615 11.442 1.78246 10.7256 1.08668C10.0092 0.390889 9.03747 0 8.02429 0C7.01112 0 6.03943 0.390889 5.32301 1.08668C4.60658 1.78246 4.2041 2.72615 4.2041 3.71014C4.2041 4.69413 4.60658 5.63782 5.32301 6.33361Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.02501 9.50732C10.0784 9.50732 12.0362 9.87834 13.8508 10.5183L12.8002 16.0001H11.6064H10.8281H5.09779H4.44358H3.24977L2.19922 10.5183C4.06602 9.85552 6.03738 9.51341 8.02501 9.50732Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageUsers);
export default __webpack_public_path__ + "static/media/ManageUsers.8a957d1dfa78540fae58e2ac58912d73.svg";
export { ForwardRef as ReactComponent };